export const PASSWORD_MIN_LENGTH = 10;

export const PASSWORD_POLICY_DESCRIPTION =
  "Use at least 10 characters with lowercase, uppercase, a number, and a symbol.";

export function validatePassword(password) {
  const value = password || "";
  const errors = [];
  if (value.length < PASSWORD_MIN_LENGTH) errors.push("Use at least 10 characters.");
  if (!/[a-z]/.test(value)) errors.push("Add a lowercase letter.");
  if (!/[A-Z]/.test(value)) errors.push("Add an uppercase letter.");
  if (!/[0-9]/.test(value)) errors.push("Add a number.");
  if (!/[^A-Za-z0-9]/.test(value)) errors.push("Add a symbol.");
  return { valid: errors.length === 0, errors };
}

export function passwordPolicyError(password) {
  const result = validatePassword(password);
  return result.valid ? null : result.errors.join(" ");
}
